import React from 'react'
import { connect } from 'react-redux'
import { Icon, Step } from 'semantic-ui-react'
import { Cont } from './styled'
import Approves from './Approvers'

const PRStep = (props) => {
  const { prData, approvers } = props
  const { status } = prData
  return (
    <Cont>
      <Step.Group size='mini'>
        <Step className={`${status === 6 ? 'stepWait' : 'stepComplete'}`}>
          <Icon name='plus circle' />
          <Step.Content>
            <Step.Title>{`${status !== 0 ? 'Created' : 'Create'}`}</Step.Title>
          </Step.Content>
        </Step>
        <Step className={`${status !== 0 ? status === 4 ? 'stepComplete' : status === 6 ? 'stepWait' : 'stepInprocess' : 'stepWait'}`}>
          <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}></div>
          <Icon name='forward' />
          <Step.Content>
            <Step.Title>In Process</Step.Title>
            {getStepActivity()}
          </Step.Content>
          <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
            <Approves approvers={approvers} status={status} trigger={<Icon name='sort numeric down' circular inverted link />} />
          </div>
        </Step>
        <Step className={`${status === 4 ? 'stepComplete' : status === 6 ? 'stepCancelled' : 'stepWait'}`}>
          <Icon name='check circle' />
          <Step.Content>
            <Step.Title>{`${status === 6 ? 'Cancelled' : status === 4 ? 'Completed' : 'Complete'}`}</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
    </Cont>
  )

  function getStepActivity() {
    if ([4, 0].indexOf(status) >= 0) return null
    if (status === 5) return <Step.Description>{'Creator update information'}</Step.Description>
    let step = approvers.find(x => x.isCurrentStep)
    if (step) {
      return <Step.Description>{step.stepName === 'GOA' ? `${step.stepName} Approval` : step.stepName}</Step.Description>
    } else {
      return null
    }
  }
}

const mapStateToProps = (state) => ({
  prData: state.pr.prDetail.data || {},
  approvers: state.pr.approvers
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PRStep)
